import React, { useEffect, useState } from "react";
import { Affix, Badge, Button, Drawer, Form, Space, Typography } from "antd";
import PickQuestionsTable from "./PickQuestionsTable";
import { createPickQuestionJSON, deepCopy } from "./PickQuestionUtil";
import { ToastContextDispatch } from "Context/CommonContext";
import { removeEmptyFields } from "utilFunctions/helperFunctions/HelperFunction";
import { BASE_URL } from "utilFunctions/Constants/urlConstants";
import PickQuestionsFilter from "Pages/MySchedule/MyScheduledBeta/quiz/QuizBuilder/QuizManualPickQuestions/PickQuestionsFilter/PickQuestionsFilter";
import ErrorBoundryComponent from "Components/CommonComponents/ErrorBoundryComponent";
import TechnicalErrorFallback from "Components/CommonComponents/TechnicalErrorFallback";
import { EXTRAA_FIELDS } from "utilFunctions/Constants/Constants";
import { getAPIRequest } from "utilFunctions/Axios/AxiosRequestConfiguration";
import { useQuizContext } from "Pages/MySchedule/MyScheduledBeta/quiz/context/QuizContext";
import PickQuestionsFooter from "Pages/MySchedule/MyScheduledBeta/quiz/QuizBuilder/QuizManualPickQuestions/components/PickQuestionsFooter";
import useWindowSize from "utilFunctions/CustomHooks/useWindowSize";
const filterStateOG = {
  checkbutton: false,
  isPaneOpen: false,
  isPaneOpenLeft: false,
  selectedTag: {
    chapterAndNodeIdObj: {
      chapterId: null,
      nodeIds: [],
    },
    node: "",
    course: "",
    newcourse: "",
    newnode: "",
    fkCourse: null,
    fkNode: "",
  },
  inputTag: null,
  nodeIndex: "",
  index: null,
  questionisPaneOpen: false,
};
const PickQuestions = () => {
  const {
    selectedQuestions,
    setSelectedQuestions,
    refresh,
    setActive,
    stepperForm,
    setGeneratedQuestions,
    generatedQuestion,
    maxQuestionLimit,
    limit,
  } = useQuizContext();
  const {
    alreadySelected = [],
    autoPick = [],
    manualPick = [],
  } = generatedQuestion || {};
  const { quizQueLim: MAXIMUM_QUESTION_COUNT } = limit || {};
  const Questions = [...alreadySelected, ...autoPick, ...manualPick];

  const { screen } = useWindowSize();
  const ToastDispatch = React.useContext(ToastContextDispatch);
  const [form] = Form.useForm();
  // const { addQuestionsImportedQuestions } = useFetchQuestions();
  const [data, setData] = useState([]);
  const [pagination, setPagination] = useState({
    pageSize: 10,
    total: 0,
    current: 1,
    pageSizeOptions: ["10", "50", "100"],
    showSizeChanger: true,
  });
  const [isLoader, setIsLoader] = useState(false);
  const [syllabusTags] = useState([]);
  const [syllabusTagValue] = useState(null);
  const [nodes, setNodes] = useState(null);
  const [isDrawerOpen, setIsDrawerOpen] = useState(false);
  const [filterState, setfilterState] = useState(filterStateOG);
  const [qIdKey, setQIdKey] = useState([]);
  const [isAIFilter, setIsAIFilter] = useState(false);
  const [filterType, setFilterType] = useState(null);
  const [newSelectedQuestions, setNewSelectedQuestions] = useState([]);
  const step2 = stepperForm["step2"];
  const { step1 } = stepperForm || {};
  const { questionType, lod1, streamId } = step1;
  useEffect(() => {
    if (refresh) {
      setQIdKey([]);
    }
  }, [refresh]);
  useEffect(() => {
    let { ret } = createPickQuestionJSON(form.getFieldsValue(true));
    callTestQuestions(pagination, ret);
  }, [pagination.current, pagination.pageSize, nodes]);
  const callTestQuestions = (pagination, ret, isClear = false) => {
    const { pageSize, current } = pagination;
    const limit = pageSize;
    const offset = (current - 1) * limit;

    // if (!nodes?.nodeIdsTagged?.length) return;

    const baseParams = `limit=${limit}&offset=${offset}`;
    let initialUrl = `${BASE_URL}question/v2/pick?${baseParams}&questionType=${questionType}&lod1=${lod1}&streamId=${streamId}&questionStatus=Published`;
    let initialUrlPag = `${BASE_URL}question/count?${baseParams}&forPickQue=true&questionType=${questionType}&lod1=${lod1}&streamId=${streamId}&questionStatus=Published`;

    // Append chapterIds and nodeIds
    ({ initialUrl, initialUrlPag } = appendChapterAndNodeParamsForNewFilter({
      filterState,
      isClear,
      nodes,
      initialUrl,
      initialUrlPag,
    }));

    // Append additional params from `ret`
    if (ret?.length) {
      const retParams = ret.join("&");
      initialUrl += `&${retParams}`;
      initialUrlPag += `&${retParams}`;
    }

    // Fetch
    fetchTestQuestions(initialUrl);
    fetchPaginationData(initialUrlPag);
  };

  const appendChapterAndNodeParamsForNewFilter = ({
    initialUrl,
    initialUrlPag,
  }) => {
    const { nodeIds = [], chapterIds = [] } = step2 || {};
    if (chapterIds?.length) {
      initialUrl += `&chapterIds=${
        isNaN(chapterIds) ? chapterIds.toString() : chapterIds
      }`;
      initialUrlPag += `&chapterIds=${
        isNaN(chapterIds) ? chapterIds.toString() : chapterIds
      }`;
    }
    if (nodeIds?.length) {
      initialUrl += `&nodeIds=${nodeIds}`;
      initialUrlPag += `&nodeIds=${nodeIds}`;
    }
    return { initialUrl, initialUrlPag };
  };

  const fetchTestQuestions = async (url) => {
    setIsLoader(true);
    getAPIRequest({
      url: url,
      success: (res) => {
        const { data: response } = res || {};
        let data = response["data"];
        setIsLoader(false);
        if (data && data.length) {
          setData(data);
        } else {
          setData([]);
        }
      },
      failure: (err) => {
        console.log(err);
        setIsLoader(false);
        setData([]);
      },
    });
  };

  const fetchPaginationData = async (url) => {
    getAPIRequest({
      url: url,
      success: (res) => {
        const { data: response } = res || {};
        setPagination({ ...pagination, total: response?.totalCount });
      },
      failure: (err) => {
        console.log(err);
      },
    });
  };
  useEffect(() => {
    if (syllabusTags && syllabusTags.length) {
      const courseId = syllabusTags[0]?.courseId;
      const url = BASE_URL + "testTags/nodes?fkCourse=" + courseId;
      fetchSyllabusNode(url);
    }
  }, [syllabusTags]);
  const fetchSyllabusNode = async (url) => {
    setIsLoader(true);
    getAPIRequest({
      url: url,
      success: (res) => {
        const { data } = res || {};
        if (data && data["response"]) {
          const parentNodes =
            data["response"]["smToc"].map((ele) => ele.key) || [];
          const checkedNodesId = data["response"]["nodeIdsTagged"] || [];
          let autoSelectedChapterIds = [];
          let autoSelectedNodeIds = [];
          if (checkedNodesId.length > 0) {
            checkedNodesId.map((item) => {
              if (parentNodes.includes(item)) {
                autoSelectedChapterIds.push(item);
              } else {
                autoSelectedNodeIds.push(item);
              }
            });
          }
          setfilterState({
            ...filterStateOG,
            selectedTag: {
              chapterAndNodeIdObj: {
                chapterId:
                  autoSelectedChapterIds.length > 0
                    ? autoSelectedChapterIds
                    : null,
                nodeIds: autoSelectedNodeIds,
              },
            },
          });
          setNodes(data["response"]);
        } else {
          setNodes(null);
        }
        setIsLoader(false);
      },
      failure: (err) => {
        setIsLoader(false);
        setNodes(null);
        console.log(err);
      },
    });
  };
  const handleRowSelection = (selectedRow) => {
    setNewSelectedQuestions(selectedRow);
  };
  const handleTableChange = (pagination) => {
    setPagination((prevPagination) => ({
      ...prevPagination,
      current: pagination.current,
      pageSize: pagination.pageSize,
    }));
  };
  const deleteExtraFields = (fieldvalues) => {
    let fields = {};
    delete fieldvalues["syllabus"];
    Object.keys(fieldvalues).forEach((key) => {
      if (!EXTRAA_FIELDS.includes(key) && !key.startsWith("branch_")) {
        fields[key] = fieldvalues[key];
      }
    });
    return fields;
  };
  const onFinish = (values) => {
    let fieldvalues = removeEmptyFields(values);
    if (Object.keys(fieldvalues).length) {
      delete fieldvalues["questionTag"];
      let { ret } = createPickQuestionJSON(fieldvalues);
      callTestQuestions(pagination, ret);
      setIsDrawerOpen(false);
    } else {
      ToastDispatch({
        isOpen: true,
        type: "Error",
        message: "Please choose at least one filter",
      });
    }
  };
  const handleReset = () => {
    form.resetFields();
    setIsAIFilter(false);
    if (pagination.current > 1) {
      setPagination({
        ...pagination,
        current: 1,
      });
    } else {
      let { ret } = createPickQuestionJSON({});
      callTestQuestions(
        {
          pageSize: 10,
          total: 0,
          current: 1,
          pageSizeOptions: ["10", "50", "100"],
          showSizeChanger: true,
        },
        ret,
        true
      );
    }
  };

  const onAddHandler = () => {
    if (
      maxQuestionLimit + newSelectedQuestions.length >
      MAXIMUM_QUESTION_COUNT
    ) {
      ToastDispatch({
        isOpen: true,
        type: "Error",
        message:
          "You have reached the maximum question limit.Please remove some questions to add more.",
      });
      return;
    }
    setSelectedQuestions((prev) => {
      const existingIds = new Set(prev.map((q) => q.questionId));
      const uniqueNewQuestions = newSelectedQuestions.filter(
        (q) => !existingIds.has(q.questionId)
      );
      return [...prev, ...uniqueNewQuestions];
    });

    setGeneratedQuestions((prev) => {
      const existingIds = new Set(
        prev?.manualPick?.map((q) => q.questionId) || []
      );
      const uniqueNewQuestions = newSelectedQuestions.filter(
        (q) => !existingIds.has(q.questionId)
      );
      return {
        ...prev,
        manualPick: [...prev["manualPick"], ...uniqueNewQuestions],
      };
    });
    setActive("3");
  };
  console.log("selectedQuestionsselectedQuestions", selectedQuestions);
  const returnFieldvalues = () => {
    const fields = deepCopy(form.getFieldsValue(true));
    const fieldvalues = deleteExtraFields(fields);
    return fieldvalues;
  };

  const length = Object.keys(returnFieldvalues()).length;
  return (
    <div>
      <Drawer
        title="Question Filter"
        width={["xs", "sm", "md"].includes(screen) ? "100%" : "50%"}
        open={isDrawerOpen}
        onClose={() => {
          setIsDrawerOpen(false);
        }}
        destroyOnClose={false}
      >
        <ErrorBoundryComponent
          errorComponent={
            <TechnicalErrorFallback
              productName="Pick Questions Filter"
              message=""
            />
          }
        >
          <PickQuestionsFilter
            form={form}
            onFinish={(values) => {
              onFinish(values);
              setFilterType("filter");
            }}
            handleReset={handleReset}
            syllabusTagValue={syllabusTagValue}
            syllabusTags={syllabusTags}
            filterState={filterState}
            setfilterState={setfilterState}
            refresh={refresh}
          ></PickQuestionsFilter>
        </ErrorBoundryComponent>
      </Drawer>

      <Affix offsetTop={0}>
        <>
          <div className="questionHeader mb-1">
            <Typography.Title level={5} className="mb-0"></Typography.Title>
            <Space>
              {!!length && (
                <Button danger type="text" onClick={handleReset}>
                  Remove filter
                </Button>
              )}
              <Badge count={length && !isAIFilter ? length : ""}>
                <Button
                  disabled={
                    filterType == null ? false : filterType === "aiFilter"
                  }
                  onClick={() => {
                    setIsDrawerOpen(!isDrawerOpen);
                  }}
                >
                  Filter
                </Button>
              </Badge>
            </Space>
          </div>
          <div className="questionContentCreationPage pl-0">
            <ErrorBoundryComponent
              errorComponent={
                <TechnicalErrorFallback
                  productName="Pick Questions Table"
                  message=""
                />
              }
            >
              <PickQuestionsTable
                data={data}
                pagination={pagination}
                loading={isLoader}
                onSelectChange={handleRowSelection}
                onPageChange={handleTableChange}
                qIdKey={qIdKey}
                setQIdKey={setQIdKey}
                disabledKeys={Questions.map((ele) => ele.questionId)}
                // qIdKey={selectedQuestions}
                scroll={{
                  x: "max-content",
                  y: ["xxl", "xl", "lg"].includes(screen)
                    ? "calc(100vh - 310px)"
                    : "calc(100vh - 340px)",
                }}
              />
            </ErrorBoundryComponent>
            <ErrorBoundryComponent
              errorComponent={
                <TechnicalErrorFallback
                  productName="Pick Questions Footer"
                  message=""
                />
              }
            >
              <PickQuestionsFooter
                onAddHandler={onAddHandler}
                selectedRows={newSelectedQuestions}
              ></PickQuestionsFooter>
            </ErrorBoundryComponent>
          </div>
        </>
      </Affix>
    </div>
  );
};

export default PickQuestions;
